import { FC } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";

import { FunnelUserTagModuleList_Query } from "~/src/__relay_artifacts__/FunnelUserTagModuleList_Query.graphql";
import {
  Table,
  TableHeaderColumn,
  TableHeaderRow,
} from "~/src/components/common/tables/Table";

import { FunnelUserTagModuleTableDataRow } from "./FunnelUserTagModuleTableDataRow";

const query = graphql`
  query FunnelUserTagModuleList_Query(
    $siteSlug: String!
    $funnelIds: [ID!]
    $pageIds: [ID!]
  ) {
    site(slug: $siteSlug) {
      userTagModules(funnelIds: $funnelIds, pageIds: $pageIds) {
        id
        name
        effectiveEnabled
        hasPendingToggle
        publishedAt
        createdAt
        popupGroups {
          id
          name
          slug
          page {
            id
          }
        }
        abtestScenarioPageGroups {
          id
          title
          slug
          page {
            id
          }
        }
      }
    }
  }
`;

type Props = {
  funnelId: string;
  pageId: string | null;
  siteSlug: string;
};

export const FunnelUserTagModuleList: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ siteSlug, funnelId, pageId }) => {
  const { site } = useLazyLoadQuery<FunnelUserTagModuleList_Query>(query, {
    siteSlug,
    funnelIds: [funnelId],
    pageIds: pageId ? [pageId] : null,
  });

  return (
    <Table>
      <TableHeaderRow>
        <TableHeaderColumn>タグ名</TableHeaderColumn>
        <TableHeaderColumn>有効状態</TableHeaderColumn>
        <TableHeaderColumn>ポップアップグループ</TableHeaderColumn>
        <TableHeaderColumn>ABテストグループ</TableHeaderColumn>
        <TableHeaderColumn>最終更新日</TableHeaderColumn>
        <TableHeaderColumn>アクション</TableHeaderColumn>
      </TableHeaderRow>
      {site.userTagModules.map((module) => (
        <FunnelUserTagModuleTableDataRow
          key={module.id}
          siteSlug={siteSlug}
          pageId={pageId}
          module={module}
        />
      ))}
    </Table>
  );
};
